export default __webpack_public_path__ + "static/media/news_4.a728ff22.png";